import React from 'react';
import {Grid} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Goals from '../../features/goals/Goals';
import {HandoverStep} from '../../components/HandoverStep/HandoverStep';
import {HandoverFooterNavigation} from '../../components/FooterNavigation/HandoverFooterNavigation';
import {useReviewContext} from '../../contexts/ReviewContext';
import useTitle from '../../hooks/useTitle';
import {ErrorPage} from '../ErrorPage';

function HandoverGoalsPage() {
  const {reviewDetails} = useReviewContext();
  useTitle(`Review goals - ${reviewDetails?.account?.name}`);

  if (!reviewDetails) {
    return <ErrorPage code="404" text="Review not found" />;
  }

  return (
    <>
      <HandoverStep />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Goals readOnly={false} />
        </Grid>
      </Grid>
      {/* this prevents the footer from obscuring the contents above */}
      <div style={{height: '4rem'}} />
      <HandoverFooterNavigation nextIcon={<TrendingUpIcon />} />
    </>
  );
}

export default HandoverGoalsPage;
